import { render, staticRenderFns } from "./DarkModeSwitcherListItem.vue?vue&type=template&id=50777b51&"
import script from "./DarkModeSwitcherListItem.vue?vue&type=script&lang=js&"
export * from "./DarkModeSwitcherListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VImg,VListItem,VListItemAvatar,VSwitch})
